/**
 * User role types - now using string-based roles
 */
export type UserRole =
  // Backend admin roles
  | 'SUPER_ADMIN'
  | 'CONTENT_MANAGER'
  | 'USER_SUPPORT'
  | 'ANALYST'
  | 'MODERATOR'
  // Legacy / existing roles
  | 'ADMIN'
  | 'MERCHANT'
  | 'CUSTOMER'
  | 'RESTAURANT_OWNER'
  | 'DELIVERY_DRIVER';

/**
 * Navigation path constants
 * Single source of truth for sidebar and routing
 */
export const NAV_PATHS = {
  HOME: '/home',
  SONGS: '/pages/songs',
  ARTISTS: '/pages/artists',
  PLAYLISTS: '/pages/playlists',
  ALBUMS: '/pages/albums',
  BANNERS: '/pages/banners',
  TRAILERS: '/pages/trailers',
  SPLASH_SCREENS: '/pages/splash-screens',
  PAYMENT_METHODS: '/pages/payment-methods',
} as const;

export type NavPathKey = keyof typeof NAV_PATHS;

/**
 * Route access levels
 */
export type AccessLevel = 'public' | 'authenticated' | 'role-specific';

/**
 * Route configuration interface
 */
export interface RouteConfig {
  path: string;
  component: React.ComponentType<any>;
  exact?: boolean;
  accessLevel: AccessLevel;
  allowedRoles?: UserRole[];
  title?: string;
  description?: string;
  requiresAuth?: boolean;
  layout?: 'default' | 'dashboard' | 'auth';
}

/**
 * Navigation item interface
 */
export interface NavigationItem {
  label: string;
  path: string;
  icon?: string;
  children?: NavigationItem[];
  requiresAuth?: boolean;
  allowedRoles?: UserRole[];
}

/**
 * Layout configuration
 */
export interface LayoutConfig {
  type: 'default' | 'dashboard' | 'auth';
  showHeader?: boolean;
  showSidebar?: boolean;
  showFooter?: boolean;
}

/**
 * Route guards result
 */
export interface RouteGuardResult {
  canAccess: boolean;
  redirectTo?: string;
  reason?: string;
}

/**
 * Breadcrumb item
 */
export interface BreadcrumbItem {
  label: string;
  path?: string;
  active?: boolean;
}
